import { ReactElement } from 'react';
import { HexColorInput, HexColorPicker } from 'react-colorful';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Label } from '../../common/Text';
import { fieldStyle } from './Input';

const Input = styled(HexColorInput)`
	${fieldStyle}
`;

interface Props {
	label: string;
	color: string;
	setColor: (value: string) => void;
}

export function ColorPicker({ label, color, setColor }: Props): ReactElement {
	const { t } = useTranslation();
	return (
		<Box justifyContent="stretch" alignItems="stretch">
			<Label mb={1}>{label}</Label>
			<HexColorPicker color={color} onChange={setColor} />
			<Flex flexDirection="column" alignItems="stretch" mt={2}>
				<Label title={t('common.colorInHex')} />
				<Input color={color} onChange={setColor} />
			</Flex>
		</Box>
	);
}
